import { IconButton, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'
import { GridInfoCard } from 'components/atoms/InfoCard'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import whyIcon from 'assets/images/why.svg'
import messagePersonBubbleIcon from 'assets/images/messagePersonBubble.svg'
import sendEmailPopupIcon from 'assets/images/sendEmailPopup.svg'
import noteAddIcon from 'assets/images/noteAdd.svg'
import { InfoCardIcon } from 'components/atoms/Icons'
import RowStack from 'components/atoms/container/RowStack'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useState } from 'react'
import InfoDialog from '../notificationOverlay/InfoDialog'
import shieldTickIcon from 'assets/images/shieldTick.svg'

export const ConfidentialIcon = () => {
  const { t } = useTranslation()
  const [confidentialDialogOpen, setDisplayConfidentialInfo] = useState(false)
  return (
    <>
      <IconButton onClick={() => setDisplayConfidentialInfo(true)}>
        <InfoOutlinedIcon />
      </IconButton>
      <InfoDialog
        open={confidentialDialogOpen}
        onClose={() => setDisplayConfidentialInfo(false)}
        title={t('confidentiality.heading')}
        buttonText={t('common.ok')}
        icon={shieldTickIcon}>
        <Typography>{t('addRaters.confidentiality')}</Typography>
      </InfoDialog>
    </>
  )
}

const AddRatersDescriptions = () => {
  const { t } = useTranslation()

  const DetailContainer = ({ icon, title, description }) => (
    <GridInfoCard
      size={3}
      icon={<InfoCardIcon src={icon} size={56} />}
      title={title}
      content={description}
    />
  )

  return (
    <>
      <Typography variant='h1' color='primary'>
        {t('feedbackArea._360Requests')}
      </Typography>
      <BoxWithBackground padding={12}>
        <Grid container spacing={12}>
          <DetailContainer
            title={t('addRaters.details.item1.title')}
            description={t('addRaters.details.item1.description')}
            icon={whyIcon}
          />
          <DetailContainer
            title={t('addRaters.details.item2.title')}
            description={t('addRaters.details.item2.description')}
            icon={messagePersonBubbleIcon}
          />
          <DetailContainer
            title={t('addRaters.details.item3.title')}
            description={t('addRaters.details.item3.description')}
            icon={sendEmailPopupIcon}
          />
          <DetailContainer
            title={t('addRaters.details.item4.title')}
            description={t('addRaters.details.item4.description')}
            icon={noteAddIcon}
          />
        </Grid>
      </BoxWithBackground>
      <RowStack width='unset' spacing={2}>
        <Typography variant='h4'>
          {t('addRaters.inviteOthersToRate')}
        </Typography>
        <ConfidentialIcon />
      </RowStack>
    </>
  )
}

export default AddRatersDescriptions
